import React from "react";
import { Input, InputGroupFlex, IconContainer } from "./styles/inputTax";
import { Icon } from "antd";

function IconInputTax(props) {
  const {
    onChange,
    name,
    style,
    iconPosition,
    iconType,
    icon,
    placeholder,
    value,
  } = props.value || props;

  const { index, obj } = props;

  return (
    <InputGroupFlex>
      {iconPosition === "start" ? (
        iconType ? (
          <IconContainer>
            <Icon type="phone" />
          </IconContainer>
        ) : (
          <IconContainer>
            <div>{icon}</div>
          </IconContainer>
        )
      ) : null}
      <Input
        style={style}
        onChange={(event) => {
          const inputValue = event.target.value;

          // Allow only numbers with up to two decimal places
          const regex = /^\d*\.?\d{0,2}$/;

          if (regex.test(inputValue)) {
            if (obj === "nestedObj") {
              onChange(index, event.target);
            } else {
              onChange(event);
            }
          }
        }}
        name={name}
        placeholder={placeholder}
        value={value}
      />
      {/* {iconPosition === "end" ? (
        <IconContainer>
          <Icon type="phone" />
        </IconContainer>
      ) : null} */}

      {iconPosition === "end" ? (
        iconType ? (
          <IconContainer>
            <Icon type="phone" />
          </IconContainer>
        ) : (
          <IconContainer>
            <div>{icon}</div>
          </IconContainer>
        )
      ) : null}
    </InputGroupFlex>
  );
}

export default IconInputTax;
